import CorporateRowWrapper from './CorporateRowWrapper';

export default CorporateRowWrapper;
